/**
 * Get the full image URL from a product image path
 * @param {string|undefined} imagePath - The image path from the product
 * @param {string} placeholder - Placeholder image URL (optional)
 * @returns {string} The full image URL
 */
export const getImageUrl = (imagePath, placeholder = 'https://via.placeholder.com/300?text=No+Image') => {
  if (!imagePath) return placeholder;
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  // Otherwise, prepend the backend URL
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  // Remove '/api' from the end if it exists since images are served from root
  const baseUrl = API_URL.replace('/api', '');
  return `${baseUrl}${imagePath}`;
};

/**
 * Handle image loading errors
 * @param {Event} e - The error event
 * @param {string} fallbackUrl - The fallback image URL
 */
export const handleImageError = (e, fallbackUrl = 'https://via.placeholder.com/300?text=Image+Not+Available') => {
  if (e.target.src !== fallbackUrl) {
    e.target.onerror = null; // Prevent infinite loop
    e.target.src = fallbackUrl;
  }
};

/**
 * Get product image URL from product data
 * @param {Object} product - The product object
 * @param {number} imageIndex - Index of the image to get (default: 0)
 * @returns {string} The image URL
 */
export const getProductImageUrl = (product, imageIndex = 0) => {
  const imagePath = product?.images?.[imageIndex];
  return getImageUrl(imagePath);
};
